import React from 'react'
import PropTypes from 'prop-types'

import { faUserHeadset } from '@fortawesome/pro-regular-svg-icons/faUserHeadset'
import { faUserHeadset as faUserHeadsetSolid } from '@fortawesome/pro-solid-svg-icons/faUserHeadset'

import MainMenuItem from 'src/components/Menu/MainMenuItem'

import useTranslations from 'src/hooks/useTranslations'
import { reverse } from 'src/routes/config'

/**
 * AuthMenu component renders a single main menu item for the Auth section.
 *
 * @component
 * @example
 * // Example usage:
 * <AuthMenu parentIsCollapsed={false} />
 *
 * @param {Object} props - Component props.
 * @param {boolean} props.parentIsCollapsed - Indicates whether the parent menu is collapsed.
 * @returns {JSX.Element} The rendered AuthMenu component.
 */
export default function AuthMenu({ parentIsCollapsed }) {
    const { t } = useTranslations('AuthMenu', 'AuthMenu')

    return (
        <MainMenuItem
            icon={faUserHeadset}
            iconActive={faUserHeadsetSolid}
            title={t('Auth')}
            to={reverse('auth-mfe')}
            parentIsCollapsed={parentIsCollapsed}
        />
    )
}

AuthMenu.propTypes = {
    /** Indicates whether the parent menu is collapsed. */
    parentIsCollapsed: PropTypes.bool.isRequired,
}
